module.exports = __webpack_public_path__ + "img/Picture11.c3f265c5.png";